const WINDOW_MS = 24 * 60 * 60 * 1000;
const WARNING_MS = 2 * 60 * 60 * 1000;
// SiteUp: três faixas do anel da janela (folga / apertando / perto de fechar).
const TIGHTENING_MS = 8 * 60 * 60 * 1000;

export const WINDOW_RING_RADIUS = 6;
export const WINDOW_RING_CIRCUMFERENCE = 2 * Math.PI * WINDOW_RING_RADIUS;

export function toEpochMs(raw) {
  if (raw == null || raw === '') return null;
  if (typeof raw === 'string') {
    const parsed = Date.parse(raw);
    return Number.isFinite(parsed) ? parsed : null;
  }
  const value = Number(raw);
  if (!Number.isFinite(value) || value <= 0) return null;
  return value < 1e12 ? value * 1000 : value;
}

export function remainingMinutes(remainingMs) {
  return Math.max(0, Math.floor((remainingMs || 0) / 60000));
}

export function formatWindowRemaining(remainingMs) {
  const minutes = remainingMinutes(remainingMs);
  if (minutes >= 60) {
    return {
      key: 'HM',
      hours: Math.floor(minutes / 60),
      minutes: minutes % 60,
    };
  }
  return { key: 'M', hours: 0, minutes };
}

export function isWindowWarning(remainingMs) {
  return remainingMs > 0 && remainingMs < WARNING_MS;
}

export function windowTone(remainingMs) {
  if (remainingMs == null || remainingMs <= 0) return 'closed';
  if (remainingMs < WARNING_MS) return 'critical';
  if (remainingMs < TIGHTENING_MS) return 'tightening';
  return 'comfort';
}

export function windowProgressPct(remainingMs) {
  if (!remainingMs || remainingMs <= 0) return 0;
  return Math.min(100, Math.round((remainingMs / WINDOW_MS) * 100));
}

export function windowRingDashOffset(remainingMs) {
  const pct = windowProgressPct(remainingMs) / 100;
  return WINDOW_RING_CIRCUMFERENCE * (1 - pct);
}

export function closesAtParts(expiresAtMs, nowMs = Date.now()) {
  if (!expiresAtMs) return null;
  const closes = new Date(expiresAtMs);
  const now = new Date(nowMs);
  const sameDay =
    closes.getDate() === now.getDate() &&
    closes.getMonth() === now.getMonth() &&
    closes.getFullYear() === now.getFullYear();

  return {
    dayKey: sameDay ? 'TODAY' : 'TOMORROW',
    hh: String(closes.getHours()).padStart(2, '0'),
    mm: String(closes.getMinutes()).padStart(2, '0'),
  };
}

export function lastIncomingAtMs(chat) {
  const messages = chat?.messages;
  if (Array.isArray(messages)) {
    for (let index = messages.length - 1; index >= 0; index -= 1) {
      const message = messages[index];
      if (Number(message?.message_type) === 0 && message.created_at) {
        return toEpochMs(message.created_at);
      }
    }
  }

  const last = chat?.last_non_activity_message;
  if (Number(last?.message_type) === 0 && last.created_at) {
    return toEpochMs(last.created_at);
  }

  return toEpochMs(chat?.last_activity_at);
}

export function formatClock(ms) {
  if (!ms) return null;
  const date = new Date(ms);
  return {
    hh: String(date.getHours()).padStart(2, '0'),
    mm: String(date.getMinutes()).padStart(2, '0'),
  };
}
